import { render, staticRenderFns } from "./mocOnepageDashboard.vue?vue&type=template&id=10c3cd3a"
import script from "./mocOnepageDashboard.vue?vue&type=script&lang=js"
export * from "./mocOnepageDashboard.vue?vue&type=script&lang=js"
import style0 from "./mocOnepageDashboard.vue?vue&type=style&index=0&id=10c3cd3a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c3cd3a')) {
      api.createRecord('10c3cd3a', component.options)
    } else {
      api.reload('10c3cd3a', component.options)
    }
    module.hot.accept("./mocOnepageDashboard.vue?vue&type=template&id=10c3cd3a", function () {
      api.rerender('10c3cd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/moc/mocOnepageDashboard.vue"
export default component.exports